import { useParams } from 'react-router-dom'
import { Header, Loader, HTMLText, Base } from '@crossfit/ui'
import { useWeeklyOverview } from '../hooks'
import Section from 'pages/Programming/components/Section'
import DailyClassPlanCard from './DailyClassPlanCard'
import Navigation from './Navigation'
import TabbedContent from './TabbedContent'
import MonthlyFocus from './MonthlyFocus'
import YouTubeVideo from 'components/YouTubeVideo'
import usePageTitle from 'hooks/usePageTitle'
import style from './style.module.css'
import ToggleSwitch from 'components/ToggleSwitch'
import { useUnitPreference } from '../components/UnitPreference'
import { trackEvent } from 'services/segment'

function WeeklyOverviewPage() {
  const { unitPreference, toggleUnitPreference } = useUnitPreference()
  const { dateSlug, track = 'affiliate' } = useParams()
  const { isLoading, dailyClassPlans, weeklyOverview } = useWeeklyOverview(
    track,
    dateSlug,
  )
  usePageTitle(
    `CrossFit Affiliate Toolkit${
      weeklyOverview?.name ? ` | ${weeklyOverview.name}` : ''
    }`,
  )

  if (isLoading) {
    return <Loader />
  }

  if (!weeklyOverview) {
    return <Loader />
  }

  const { monthlyFocus, workYourWeakness, atAGlance, slugs, date } =
    weeklyOverview

  const onCopy = (e) => {
    trackEvent({
      component: 'Weekly Overview',
      event: 'Weekly Overview Copied',
      location: 'Affiliate Toolkit',
      text: e.target.innerText,
    })
  }

  return (
    <>
      <Navigation track={track} date={date} slugs={slugs} />

      <main onCopy={onCopy}>
        <Section>
          <Base as='header' className={style.header} mb={8}>
            <Header size='xlarge' mb={3} className={style.headerText}>
              Workouts
            </Header>

            <ToggleSwitch
              options={['Imperial', 'Metric']}
              selectedOption={unitPreference}
              onClick={toggleUnitPreference}
            />
          </Base>

          <div className={style.cards}>
            {dailyClassPlans.map((dailyClassPlan) => (
              <DailyClassPlanCard
                key={dailyClassPlan.slug}
                dailyClassPlan={dailyClassPlan}
              />
            ))}
          </div>

          {monthlyFocus && <MonthlyFocus {...monthlyFocus} />}
        </Section>

        {workYourWeakness && (
          <Section color='black'>
            <Header as='h2' size='xlarge' mb={[12, 8]}>
              Work Your Weakness
            </Header>
            <div className={style.cards}>
              {workYourWeakness.map((workout) => (
                <div className={style.card} key={workout.title}>
                  <Header as='h4' size='medium' mb={2}>
                    {workout.title}
                  </Header>
                  <HTMLText>{workout.body}</HTMLText>
                </div>
              ))}
            </div>
          </Section>
        )}

        {atAGlance && (
          <Section>
            <Header as='h2' size='xlarge' mb={[12, 8]}>
              About the week
            </Header>

            <TabbedContent
              content={[
                {
                  tab: 'Overview',
                  content: (
                    <>
                      {atAGlance.youtubeId && (
                        <YouTubeVideo id={atAGlance.youtubeId} />
                      )}
                      {atAGlance.overview && (
                        <HTMLText>{atAGlance.overview}</HTMLText>
                      )}
                    </>
                  ),
                },
                {
                  tab: 'Weekly Tip',
                  content: (
                    <>
                      <HTMLText>{atAGlance.weeklyTip}</HTMLText>
                    </>
                  ),
                },
              ]}
            />
          </Section>
        )}
      </main>
    </>
  )
}

export default WeeklyOverviewPage
